import styled from 'styled-components';

const UnstyledList = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
`;

export { UnstyledList };
